import { c as _c } from "react/compiler-runtime";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "cn";
import type * as React from "react";
import { BRAND_MARKS, type CanteraLogoVariant } from "./CanteraBrandMarks";
const canteraLogoVariants = cva("block w-auto shrink-0 text-jade-500", {
  variants: {
    size: {
      xs: "h-4",
      sm: "h-6",
      md: "h-8",
      lg: "h-12",
      xl: "h-16"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
type CanteraLogoSize = NonNullable<VariantProps<typeof canteraLogoVariants>["size"]>;
type CanteraLogoProps = Omit<React.ComponentProps<"svg">, "viewBox" | "children"> & VariantProps<typeof canteraLogoVariants> & {
  variant?: CanteraLogoVariant;
};
function CanteraLogo(t0) {
  const $ = _c(24);
  let className;
  let props;
  let size;
  let style;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      variant: t1,
      size,
      className,
      style,
      "aria-label": t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = size;
    $[4] = style;
    $[5] = t1;
    $[6] = t2;
  } else {
    className = $[1];
    props = $[2];
    size = $[3];
    style = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const variant = t1 === undefined ? "logo" : t1;
  const ariaLabel = t2 === undefined ? "Cantera" : t2;
  const {
    width,
    height,
    paths
  } = BRAND_MARKS[variant];
  const hidden = props["aria-hidden"] === true || props["aria-hidden"] === "true";
  let t3;
  if ($[7] !== className || $[8] !== size) {
    t3 = cn(canteraLogoVariants({
      size
    }), className);
    $[7] = className;
    $[8] = size;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = `0 0 ${width} ${height}`;
  const t5 = hidden ? undefined : "img";
  const t6 = hidden ? undefined : ariaLabel;
  const t7 = `${width} / ${height}`;
  let t8;
  if ($[10] !== style || $[11] !== t7) {
    t8 = {
      aspectRatio: t7,
      ...style
    };
    $[10] = style;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== paths) {
    t9 = paths.map(_temp);
    $[13] = paths;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== props || $[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t8 || $[21] !== t9 || $[22] !== variant) {
    t10 = <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" data-slot="cantera-logo" data-variant={variant} className={t3} {...props} viewBox={t4} role={t5} aria-label={t6} style={t8}>{t9}</svg>;
    $[15] = props;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
    $[22] = variant;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}
function _temp(d) {
  return <path key={d} d={d} />;
}
export { CanteraLogo, type CanteraLogoProps, type CanteraLogoSize, type CanteraLogoVariant };